export enum RejectionFlags {
    None = 1,
    NonCompliant = 2,
    Duplicate = 4,
    NonQualified = 8,
    Archived = 16,
}
